var SettingsService = (function (backOffice, $) {
    backOffice.SettingsService = (function () {
        function get(settingName, toggleLoader = true, success = null, error = null, complete = null) {
            if (!settingName) {
                return;
            }

            if (toggleLoader) {
                backOffice.ToggleLoader(true);
            }

            $.ajax({
                url: window.location.origin + "/dotnet/admin/api/settings",
                type: "GET",
                data: { name: settingName },
                dataType: 'json',
                contentType: "application/json; charset=utf-8",
                success: function (data, status, xhr) {
                    if (success) {
                        success(data, status, xhr);
                    }
                },
                error: function (xhr, status, err) {
                    if (error) {
                        error(xhr, status, err);
                    }
                },
                complete: function (xhr, status) {
                    if (complete) {
                        complete(xhr, status);
                    }

                    if (toggleLoader) {
                        backOffice.ToggleLoader(false);
                    }
                }
            });
        }
        function getCurrentUserEmail(toggleLoader = true, success = null, error = null, complete = null) {
            if (toggleLoader) {
                backOffice.ToggleLoader(true);
            }

            $.ajax({
                url: window.location.origin + "/dotnet/admin/api/currentuseremail",
                type: "GET",
                dataType: 'json',
                contentType: "application/json; charset=utf-8",
                success: function (data, status, xhr) {
                    if (success) {
                        success(data, status, xhr);
                    }
                },
                error: function (xhr, status, err) {
                    if (error) {
                        error(xhr, status, err);
                    }
                },
                complete: function (xhr, status) {
                    if (complete) {
                        complete(xhr, status);
                    }

                    if (toggleLoader) {
                        backOffice.ToggleLoader(false);
                    }
                }
            });
        }
        return $.extend(backOffice.SettingsService, {
            Get: get,
            GetCurrentUserEmail: getCurrentUserEmail
        });
    })();

    return backOffice.SettingsService;

})(BackOffice || {}, jQuery);